<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getStudents () {
    //   this.$store.dispatch('getStudents')
    // },

    getFamilies () {
      this.$store.dispatch('getFamiliesLimit0')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getUsers () {
      this.$store.dispatch('getUsersSelect')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getStudents()
      vm.getFamilies()
      vm.getOffices()
      vm.getUsers()
      vm.getCompanies()
      vm.getPrefs()
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// States.vue?3a78d35d